import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { RoleListComponent } from '@fi-app/role/role-list/role-list.component';

export const FiRoleListState: Ng2StateDeclaration = {
    name: FiStateNames.Role.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: RoleListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiRoleListStateResolve_pageTitle],
    },
};

export function FiRoleListStateResolve_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByItem(ObjectTypes.Role);
}
